export const normalizeCost = (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;

  const raw = String(value).trim();
  if (!raw) return null;

  const cleaned = raw.replace(/\s/g, '').replace(/[^\d,.-]/g, '');
  if (!cleaned) return null;

  const lastComma = cleaned.lastIndexOf(',');
  const lastDot = cleaned.lastIndexOf('.');
  let normalized = cleaned;

  if (lastComma > -1 && lastDot > -1) {
    const decimalSeparator = lastComma > lastDot ? ',' : '.';
    const thousandsSeparator = decimalSeparator === ',' ? '.' : ',';
    normalized = cleaned
      .replaceAll(thousandsSeparator, '')
      .replace(decimalSeparator, '.');
  } else if (lastComma > -1) {
    normalized = cleaned.replace(',', '.');
  }

  const number = Number(normalized);
  return Number.isFinite(number) ? number : null;
};

export const hasValidCost = (issue) => normalizeCost(issue?.cost) !== null;
